export default {
    title: 'trends_scene_title',
    highlightText: 'trends_scene_highlight_text',
    gendersTitle: 'filter_gender_title',
    ageGroupsTitle: 'filter_age_group_title',
    measuresTitle: 'filter_measure_title',
    metricsTitle: 'filter_metric_title',
    causesTitle: 'filter_cause_title',
    locationsTitle: 'filter_location_title',
    saveAsImage: 'map_chart_save_as_image',
};
